import {Inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({providedIn: "root"})
export class PaymentReasonsService {
  apiPayments: string = '';

  constructor(private http: HttpClient,
              @Inject('environment') private environment: any) {

    this.apiPayments = environment.apiPayments;
  }

  getPaymentsReasons(): Observable<any> {
    const url = `${this.apiPayments}/international/reasons`
    return this.http.get(url)
  }

}
